export default function isValidDomain(domain: string): boolean {
  return !!domain
    .toLowerCase()
    .match(
      /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/
    );
}
